var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.75 85.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.88,
    cy: 42.88,
    r: 42.88,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.88,
    cy: 42.88,
    r: 42.88,
    fill: "#1eaff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,62.78c2.42,2.23,6,3.1,9.3,3.1,6.21,0,10.47-4.17,12.7-7.17a8.43,8.43,0,0,0,8.44,7.17q4.35,0,7-5.24a48.58,48.58,0,0,0,2.91-9.59.89.89,0,0,0-1-.87c-.87,0-1,.48-1.35,1.93-1.46,5.72-3.3,11.83-7.27,11.83-2.82,0-3-2.52-3-4.46,0-2.23.87-5.72,1.55-8.63L58,40.39c.38-1.85,1.45-6.21,1.93-8,.59-2.33,1.65-6.5,1.65-6.88A2.45,2.45,0,0,0,59,23.13c-.88,0-2.91.39-3.69,3.3L48.52,53.37a6.6,6.6,0,0,1-1.75,3.69c-1.16,1.65-4.94,6.88-11.05,6.88-5.43,0-7.17-4-7.17-8.53a36.76,36.76,0,0,1,1.26-7.85l4.36-17.45a52.5,52.5,0,0,0,1.26-5.52,2.42,2.42,0,0,0-2.52-2.43c-.87,0-3,.29-3.78,3.4l-14,56.12a8.07,8.07,0,0,0-.3,1.65,2.45,2.45,0,0,0,2.62,2.42c2.81,0,3.39-2.23,4.07-4.94Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMew);
export default __webpack_public_path__ + "static/media/mew.d4decb574761e8da5b8749078b9eb898.svg";
export { ForwardRef as ReactComponent };